import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router, NavigationEnd, Event } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, distinctUntilChanged } from 'rxjs/operators';
import { LS } from 'src/app/helpers/localStorage.enum';
import { ILocation } from 'src/app/services/location/location.service';
import { SplitViewService } from 'src/app/services/split-view/split-view.service';
import { LocationStoreService } from 'src/app/stores/location-store/location-store.service';

@Component({
  selector: 'app-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.sass'],
})
export class DetailsComponent implements OnInit, OnDestroy {
  currLocId;
  prevLocId;
  data;
  prevData;
  activatedRouterSub: Subscription;
  dataServiceSub: Subscription;
  mapLayerServiceSub: Subscription;
  permissions: any;
  splitScreenOn = false;
  selectedModule;
  videoLocation = [
    '1A5310A(2)',
    '1A5320A(1)',
    '1A5320A(2)',
    '1A5320A(3)',
    '1B4210A(1)',
    '1B4210A(3)',
    '1B4230A',
    'Kattupalli MFFK',
    'Wilhelm Busch Schule',
    'Leitungen',
    'Polygon SECT 22-00',
    'Polygon SECT 22-37',
    'Polygon SECT 23-15',
    'Albstadt',
  ];
  showVid = false;

  constructor(
    private splitViewService: SplitViewService,
    private locationStore: LocationStoreService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    this.dataServiceSub = this.locationStore.currLocation$.subscribe(
      (res: ILocation) => {
        if (res.id) {
          this.data = res;
          let find = this.videoLocation.find((e) => e === this.data.name);
          this.showVid = find ? true : false;
          this.router.events
            .pipe(
              filter((event: Event) => event instanceof NavigationEnd),
              distinctUntilChanged()
            )
            .subscribe(() => {
              this.getPathModule(
                this.activatedRoute.snapshot['_routerState'].url
              );
            });
        }
      }
    );
  }

  ngOnInit(): void {
    this.getPathModule(this.router.url);
    this.permissions = JSON.parse(
      localStorage.getItem(LS.currentUser)
    ).permissions;

    this.splitViewService.onEvent$.subscribe((res) => {
      if (res.isSplitscreenOn === undefined) return;
      this.splitScreenOn = res.isSplitscreenOn;
      if (res.isSplitscreenOn) {
        this.router.navigate([
          'projects',
          this.data?.id,
          'details',
          'annotations',
        ]);
      }
    });
  }

  ngOnDestroy() {
    if (this.activatedRouterSub) this.activatedRouterSub.unsubscribe();
    if (this.dataServiceSub) this.dataServiceSub.unsubscribe();
    if (this.mapLayerServiceSub) this.mapLayerServiceSub.unsubscribe();
  }

  getPathModule(url) {
    let module = url.split('/');
    this.selectedModule = module[4];
  }

  selectModule(module) {
    this.selectedModule = module;
  }
}
